export function checkRole(allowedRoles, userRole) {
  return allowedRoles.includes(userRole);
}